<script>
import forminput from "@/router/views/FormComponet/forminput.vue"; 
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrHesapKodlari from "@/models/StrHesapKodlari";
export default {
  mixins: [Api, Sabit, StrHesapKodlari],
  props: ["Id", "AddEdit", "AddUstId"],
  data() {
    return {
      FormData: {},
      Kademe: 0,
      HesapKodlariDuzListe: [],
    };
  },
  components: {
    Loader,
    forminput, 
  },
  watch: {
    Id() {
      this.FormData = {};
      this.FormData = this.Id;
       
    }, 
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
       
          this.Update("StrHesapKodlari", this.FormData).then((res) => {
            if (res) {
              this.$emit("Update", this.FormData);
              this.$bvModal.hide("StrHesapKodlari");
            }
          });
         
      }
    },
    Get() {
     
   
    },
  
  },
};
</script>
<template>
  <Loader>
    <b-modal
      id="StrHesapKodlari"
      size="lg"
      :title="
        this.AddEdit == 'Edit'
          ? $t('StrHesapKodlari.AddEdit.FormTitleEdit')
          : $t('StrHesapKodlari.AddEdit.FormTitleAdd')
      "
      title-class="font-18"
      hide-footer
    >
      <Form @submit.prevent="onSubmit">
        
        <forminput 
          :FormDataType="FormDataType.Parasalustlimit"
          :Value="FormData.Parasalustlimit"
          :v="$v.FormData.Parasalustlimit"
          @input="FormData.Parasalustlimit = $event"
        />
        <button class="btn btn-primary" type="submit">
          {{ $t("StrHesapKodlari.AddEdit.Button") }}
        </button>
      </Form>
    </b-modal>
  </Loader>
</template>
